import React from 'react'
import { cn } from '../utils/utils'

const defaultItems = [{label:'', value:''}]

const Tablist = ({onValueChange, items=defaultItems, value, className}) => {

   

  return (
    <div className={cn('bg-neutral-100 p-1 w-fit flex gap-2', className)}>
        {items.map((item, index) => {
            return (
                <button onClick={()=>{ onValueChange(item.value) }} className={`${value === item.value && 'bg-white text-neutral-800'} rounded-sm h-10 px-2 font-semibold text-neutral-400 hover:text-neutral-600`} key={index}>{item.label}</button>
            )
        })}
    </div>
  )
}

export default Tablist